import React from 'react';
import { useNoAuthHooks } from '../../../../../../../../Hooks/hooks';
import useMenuItemDialog from './menuDialog-hook';
import useLanguagesHooks from '../../../../../../../../Components/Languages/setLanguage-hooks';
import { IMenuItemResponce, IMenuListItem } from '../../../../../../../../Interfaces/responseTypes';
import { ButtonTypes, ICartItem, ItemCounterTypes } from '../../../../../../../../Interfaces/componentTypes';
import ItemCounter from '../../ItemCounter/itemCounter';
import Button from '../../../../../../../../Components/Button/button';
import { ButtonCart } from '../../../../../../../../Assets/Icons';
import styles from './menuItemDialog.module.scss';
import { PencilIcon } from '../../../../../../../../Components/IconComponents';
import CustomDialog from '../../../../../../../../Components/Dialog/customDialog';
import NoteDialog from '../NoteDialog/noteDialog';

export interface IMenuItemDialogProps {
  category: IMenuListItem,
  itemData: IMenuItemResponce,
  mainCart: ICartItem[] | [];
  onClose: () => void;
  addToMainCart: (item: ICartItem) => void;
  currencySymbol: string,
};

const MenuItemDialog: React.FC<IMenuItemDialogProps> = (props) => {
  const { itemData, currencySymbol, addToMainCart, onClose } = props;
  const { t, activeLanguage } = useLanguagesHooks();
  const { baseURL, renderOptions } = useNoAuthHooks();
  const {
    open,
    cart,
    total,
    animate,
    existingItem,
    localizedTitle,
    isButtonActive,
    localizedDescription,
    handleAddNote,
    onOpenNoteDialog,
    onCloseNoteDialog,
    handleAddOption,
  } = useMenuItemDialog(props);

  return (
    <div className={styles.container}>
      <img src={`${baseURL}${itemData.image}`} className={styles.image} alt='image.png' />
      <div className={styles.infoBox}>
        <div className={styles.body}>
          <div className={styles.info}>
            <div className={styles.itemTitle}>
              <p>
                {String(localizedTitle)}
              </p>
            </div>
            {
              itemData[`description_${activeLanguage}` as keyof IMenuItemResponce]
              &&
              <div className={styles.description}>
                <p>
                  {String(localizedDescription)}
                </p>
              </div>
            }
          </div>
          <div className={styles.optionsBox}>
            <div className={styles.optionsBoxTitle}>
              <p>
                {t("Visitor.Options_Title")}
              </p>
            </div>
            {
              itemData.option.map((item) => {
                const existingOption = cart.option.find((cartItem) => cartItem.option_id === item.option_id);
                const count = existingOption?.count ?? (itemData.option.length === 1 ? 1 : 0)
                return (
                  <div className={styles.optionRow} key={item.option_id}>
                    <div className={styles.optionInfo}>
                      <p className={styles.optionType}>
                        {renderOptions(item)}
                      </p>
                      <div className={styles.optionPrice}>
                        <p>
                          {parseInt(item.price)}
                        </p>
                        <p>
                          {currencySymbol}
                        </p>
                      </div>
                    </div>
                    <ItemCounter
                      option={{ ...item, count: 0 }}
                      handleAddOption={handleAddOption}
                      count={count}
                      type={ItemCounterTypes.CART}
                    />
                  </div>
                )
              })
            }
          </div>
          <div className={`${styles.totalBox} ${animate ? styles.animateIn : ''}`}>
            {
              total > 0
              &&
              <>
                <p>{t('Visitor.Total')}</p>
                <span>{`${total} ${currencySymbol}`}</span>
              </>
            }
          </div>
          <div className={`${cart.note ? styles.noteBox : styles.noteRow}`} onClick={onOpenNoteDialog}>
            {
              cart.note
              &&
              <p className={styles.noteText}>
              {cart.note.length > 30
                ? `${cart.note.slice(0, 30)}...`
                : cart.note}
            </p>
            }
            <div className={styles.noteIcon}>
              <PencilIcon color={`var(--input-label)`} />
            </div>
            {
              !cart.note
              &&
              <span>{t('Visitor.Add_Note')}</span>
            }
          </div>
        </div>
        <Button
          buttonType={existingItem || isButtonActive ? ButtonTypes.Primery : ButtonTypes.Disabled}
          onClick={() => {
            addToMainCart(cart);
            onClose()
          }}
          title={existingItem ? t('Buttons.Save') : t('Buttons.Add_Cart')}
          leftIcon={ButtonCart}
          disable={existingItem ? false : !isButtonActive}
          buttonStyle={styles.addButton}
          buttonTitleStyle={styles.addButtonTitle}
        />
      </div>
      <CustomDialog
        open={open}
        onClose={onCloseNoteDialog}
        children={
          <NoteDialog
            note={cart.note}
            onHandleNote={handleAddNote} />}
      />
    </div>
  )
}

export default MenuItemDialog
